module.exports = __webpack_public_path__ + "static/media/step-3.1d046627.png";